import React from "react";
import FootballSquadTable from "./FootballSquadTable";
import NoDataFound from "../../common/NoDataFound";

const TeamSquad = ({
  teamSquad,
  dictionary,
  websiteBaseUrl,
  dataPath,
  dataClient = false,
}) => {
  // Check if any squad data exists
  const hasData =
    teamSquad?.Defender?.length ||
    teamSquad?.Midfielder?.length ||
    teamSquad?.Striker?.length ||
    teamSquad?.Goalkeeper?.length;

  if (!hasData) {
    return <NoDataFound text="No squad data available" />;
  }

  return (
    <div className="squad_block_wrp">
      {teamSquad?.Goalkeeper?.length > 0 && (
        <div className="squad_block">
          <div className="squad_block_hd">
            <h2>Goalkeeper</h2>
          </div>
          <FootballSquadTable
            defender={teamSquad.Goalkeeper}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            dataClient={dataClient}
          />
        </div>
      )}
      {teamSquad?.Defender?.length > 0 && (
        <div className="squad_block">
          <div className="squad_block_hd">
            <h2>Defender</h2>
          </div>
          <FootballSquadTable
            defender={teamSquad.Defender}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            dataClient={dataClient}
          />
        </div>
      )}
      {teamSquad?.Midfielder?.length > 0 && (
        <div className="squad_block">
          <div className="squad_block_hd">
            <h2>Midfielder</h2>
          </div>
          <FootballSquadTable
            defender={teamSquad.Midfielder}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            dataClient={dataClient}
          />
        </div>
      )}
      {teamSquad?.Striker?.length > 0 && (
        <div className="squad_block">
          <div className="squad_block_hd">
            <h2>Forward</h2>
          </div>
          <FootballSquadTable
            defender={teamSquad.Striker}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            dataClient={dataClient}
          />
        </div>
      )}
    </div>
  );
};

export default TeamSquad;
